import { DatePicker, Input, InputNumber } from 'antd';
import classNames from 'classnames';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Controller } from 'react-hook-form';
import InputTitle from '../../inputTitle';
import './style.scss';


const NormalInput = (props) => {
  const onChangeNormal = (e) => {
    if (props.type !== 'number') {
      props.onChange(props.name, e.target.value);
    } else {
      props.onChange(props.name, e);
    }
  };

  const onChangeDate = (date, dateString) => {
    props.onChange(props.name, dateString);
  };

  const onBlurNormal = () => {
    props.onBlur();
  };
  const renderInputType = (onChange, onBlur, value, ref) => {
    switch (props.type) {
      case 'textarea':
        return (
          <Input.TextArea
            ref={ref}
            name={props.name}
            value={value}
            disabled={props.disabled}
            placeholder={props.placeholder}
            defaultValue={props.defaultValue}
            maxLength={props.maxLength}
            showCount={props.showCount}
            prefix={props.prefix}
            suffix={props.suffix}
            onChange={onChange}
            onBlur={onBlur}
          />
        );
      case 'password':
        return (
          <Input.Password
            ref={ref}
            name={props.name}
            value={value}
            disabled={props.disabled}
            placeholder={props.placeholder}
            defaultValue={props.defaultValue}
            maxLength={props.maxLength}
            showCount={props.showCount}
            prefix={props.prefix}
            suffix={props.suffix}
            onChange={onChange}
            onBlur={onBlur}
          />
        );
      case 'number':
        return (
          <InputNumber
            ref={ref}
            name={props.name}
            value={value}
            width="100%"
            placeholder={props.placeholder}
            defaultValue={props.defaultValue}
            min={props.min}
            max={props.max}
            step={props.step}
            prefix={props.prefix}
            suffix={props.suffix}
            onChange={onChange}
            onBlur={onBlur}
          />
        );
      case 'date':
        return (
          <DatePicker
            ref={ref}
            inputRef
            name={props.name}
            value={value}
            disabled={props.disabled}
            disabledDate={props.disabledDate}
            placeholder={props.placeholder}
            format="DD/MM/YYYY"
            getPopupContainer={() => document.getElementsByClassName('input-wrapper')[0]}
            onChange={onChange}
            onBlur={onBlur}
          />
        );
      default:
        return (
          <Input
            ref={ref}
            name={props.name}
            value={value}
            status={props.errMsg && 'error'}
            disabled={props.disabled}
            placeholder={props.placeholder}
            defaultValue={props.defaultValue}
            maxLength={props.maxLength}
            showCount={props.showCount}
            prefix={props.prefix}
            suffix={props.suffix}
            onChange={onChange}
            onBlur={onBlur}
          />
        );
    }
  };

  const renderErrorMessage = () => (
    <div className="error-message mt-4">
      <p>{props.errMsg}</p>
    </div>
  );

  return (
    <div className={classNames('input-wrapper', props.className)}>
      { props.title && (
        <InputTitle
          className="mb-2"
          title={props.title}
          isRequired={props.isRequired}
          isChangePassword={props.isChangePassword}
          onForgetPasswordClick={props.onForgetPasswordClick}
        />
      )}
      {props.isUseForm ? (
        <Controller
          control={props.control}
          name={props.name}
          render={({
            field: {
              onChange, onBlur, value, ref,
            },
          }) => (
            <>
              {renderInputType((e) => {
                if (props.isNumeric) {
                  const { value } = e.target;
                  // check value is numeric
                  const reg = /^\d+$/;
                  if ((!_.isNaN(value) && reg.test(value)) || value === '') {
                    onChange(e);
                  }
                } else {
                  onChange(e);
                }
              }, () => {
                onBlurNormal();
                onBlur();
              }, value, ref)}
            </>
          )}
        />
      ) : (
        <>
          {renderInputType(props.type === 'date' ? onChangeDate : onChangeNormal, () => { }, props.value, undefined)}
        </>
      )}
      {props.errMsg && renderErrorMessage()}
    </div>
  );
};

NormalInput.defaultProps = {
  className: '',
  isRequired: false,
  isUseForm: false,
  isChangePassword: false,
  isNumeric: false,
  title: '',
  type: '',
  placeholder: '',
  defaultValue: '',
  disabled: false,
  maxLength: 100,
  showCount: false,
  prefix: undefined,
  suffix: undefined,
  value: '',
  name: '',
  min: 0,
  max: 1000,
  step: 1,
  errMsg: '',
  disabledDate: undefined,
  control: undefined,

  onChange: () => {},
  onBlur: () => {},
  onForgetPasswordClick: () => {},
};

NormalInput.propTypes = {
  className: PropTypes.string,
  isRequired: PropTypes.bool,
  isUseForm: PropTypes.bool,
  isChangePassword: PropTypes.bool,
  title: PropTypes.string,
  isNumeric: PropTypes.bool,
  type: PropTypes.oneOf(['text', 'textarea', 'password', 'number', 'date', '']),
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  maxLength: PropTypes.number,
  showCount: PropTypes.bool,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  errMsg: PropTypes.string,

  control: PropTypes.shape(),
  disabledDate: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onForgetPasswordClick: PropTypes.func,
};

export default NormalInput;
